<div *isLoading="loading()">
  <ds-header
    brandLogos="BMW"
    appName="{{ title() }}"
    [userInfo]="userInformation()"
    [labellingConfig]="headerLabellingConfig()"
    [(localeID)]="localeID"
    [localeOptions]="localeOptionActive"
    (localeIDChange)="changeLocale($event)"
    [menuTemplate]="extraOptionsTemplate"
    (requestLogout)="logout()"
    [guardImprint]="true"
    (requestImprintOpen)="imprintModal.modalIsOpen.set(true)"
    id="ds-header-id"
  >
    @if (router.url.includes('/backoffice')) {
      <ds-tag [tone]="tagTone.INFO">
        {{ 'backoffice.title' | translate }}
      </ds-tag>
    }
  </ds-header>

  <div class="application-page d-flex">
    <!-- BatteryCare - navigation bar visibility based on user's roles -->
    @if (showNavigationBar()) {
      <ds-navigation-bar
        disableImprint
        style="border-right: 1px solid var(--ds-color-border-neutral)"
        [activeItemId]="currentNavigationPage()"
        [items]="navigationItems()"
        [isExpanded]="isExpanded()"
      >
      </ds-navigation-bar>
    }
    <div class="application-page-content">
      <router-outlet />
    </div>
  </div>

  <div class="create-ticket-btn">
    <ds-button
      id="btn-create-ticket"
      icon="ticket"
      class="ds-button ds-button--primary ds-no-motion has-icon"
      (click)="openCreateTicket()"
    >
      {{ 'dashboard.ticketBtn.createTicketBtn' | translate }}
    </ds-button>
  </div>
</div>

<ng-template #extraOptionsTemplate>
  <ds-list-item class="legal-terms p-0x extra-options-item">
    <ds-tree
      [class.legal-terms-deselect-tree]="
        !legalNoticeModalOpen && !termsAndConditionsModalOpen && !dataPrivacyDisclaimersModalOpen
      "
      [items]="legalTerms"
      (selectedItemsIDs)="openLegalTermsModal($event)"
    >
    </ds-tree>
  </ds-list-item>

  <ds-list-item icon="help" [isHoverable]="true" (click)="openCompassLink()" id="compass-button" class="extra-options-item">
    COMPASS
  </ds-list-item>

  <ds-list-item icon="translate" [isHoverable]="true" (click)="openLanguageSettingsModal()" id="change-language-button" class="extra-options-item">
    {{ 'header.languageSettingsModal.title' | translate }}
  </ds-list-item>
</ng-template>

<pure-imprint-modal #imprintModal></pure-imprint-modal>
